import * as _ from 'lodash';

import ICalibrationUsesVal = ZoneIQCalibration.ICalibrationUsesVal;
import { BaseMutableModel } from '../common-models/base-mutable-model.model';
import { ICalibrationUsesValModel } from 'src/app/interfaces/calibration-uses-val-model.interface';
import ICalibrationUsesLabel = ZoneIQCalibration.ICalibrationUsesLabel;
import IAllowedUse = ZoneIQCalibration.IAllowedUse;
import { NA_VALUE } from 'src/app/constants';

export class CalibrationUsesValModel extends BaseMutableModel<ICalibrationUsesValModel>
    implements ICalibrationUsesValModel {
    Id?: number;
    ZoneCombinationId?: number;
    OverlayId?: number;
    RevisionId?: number;

    CalibrationUsesLabelId: number;
    AllowedUsesId: number;
    UseLimit?: number;
    ParkingRequired?: number;

    usesLabel: ICalibrationUsesLabel;
    allowedUse: IAllowedUse;

    constructor(data: ICalibrationUsesVal, usesLabel?: ICalibrationUsesLabel, allowedUse?: IAllowedUse) {
        super(data, ['Id', 'ZoneCombinationId', 'OverlayId']);
        this.usesLabel = usesLabel;
        this.allowedUse = allowedUse;
    }

    isEmpty(notAllowedUseId: number) {
        return (
            this.currentState.Id &&
            this.currentState.UseLimit === null &&
            this.currentState.ParkingRequired === null &&
            (this.currentState.OverlayId
                ? this.currentState.AllowedUsesId === NA_VALUE
                : this.currentState.AllowedUsesId === notAllowedUseId)
        );
    }

    getCombinedValidationResult(calibrationSet?: any, ignoreRequiredFields = false): string[] {
        const validationResult = this.getValidationResults(calibrationSet, ignoreRequiredFields);
        return _.keys(validationResult).reduce((acc, key) => {
            return acc.concat(validationResult[key].isValid.map(message => `${key}: ${message}`));
        }, []);
    }
}
